var $060018a1c3ec2fce$exports = {};
$060018a1c3ec2fce$exports = {
    "decrease": (args)=>`Sn\xed\u{17E}it ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}it ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};


export {$060018a1c3ec2fce$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
